import { createContext } from "react";
import type { PromptInputControllerProps } from "./PromptInputControllerProps";

export const PromptInputController =
  createContext<PromptInputControllerProps | null>(null);
